import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import AskKikiWidget from './index';
import { AskKikiProvider } from './context/AskKikiContext';

const GlobalAskKiki: React.FC = () => {
  const location = useLocation();
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    // Hide the widget only on specific pages where it might be intrusive
    const hiddenRoutes = ['/onboarding/success', '/payment/success', '/payment/failure'];
    
    if (!hiddenRoutes.includes(location.pathname)) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  }, [location.pathname]);

  if (!isVisible) {
    return null;
  }

  return (
    <div data-no-print className="askkiki-widget">
      <AskKikiProvider>
        <AskKikiWidget />
      </AskKikiProvider>
    </div>
  );
};

export default GlobalAskKiki;
